<rk-modal-wrapper
  [title]="'SCHEDULE.PROGRAMS.ADD_PLAYLIST' | translate"
  [submitText]="'SHARE.MODAL.ADD' | translate"
  [showCancel]="false"
  [isSubmitDisabled]="addPlaylistForm.invalid"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  (submitted)="submit()"
>
  <form [formGroup]="addPlaylistForm" class="add-playlist-form">
    <div *ngIf="(playlists$ | async)?.length">
      <rk-dropdown-autocomplete
        formControlName="selectedPlaylist"
        [label]="'MODAL.ADD_PLAYLIST.PLAYLIST' | translate"
        [data]="playlists$ | async"
        [modal]="true"
        [dropdownWidth]="220"
        [playlistTemplate]="true"
        [placeholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
      ></rk-dropdown-autocomplete>
    </div>

    <rk-form-field [label]="'MODAL.ADD_PLAYLIST.TYPE' | translate">
      <mat-radio-group rkInput formControlName="sorting">
        <mat-radio-button value="Sequential">{{
          'MODAL.ADD_PLAYLIST.SEQUENTIAL' | translate
        }}</mat-radio-button>
        <mat-radio-button value="Random">{{
          'MODAL.ADD_PLAYLIST.RANDOM' | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </rk-form-field>

    <rk-form-field
      [label]="'MODAL.ADD_PLAYLIST.TRACKS_NUMBER' | translate"
      [hintQuestionMark]="'MODAL.ADD_PLAYLIST.HINT_TRACKS_NUMBER' | translate"
    >
      <input
        rkInput
        type="number"
        inputType="num"
        formControlName="tracksNumber"
        pKeyFilter="num"
        min="1"
      />
    </rk-form-field>
  </form>
</rk-modal-wrapper>
